import { render, staticRenderFns } from "./list.vue?vue&type=template&id=c4c141fe&scoped=true"
import script from "./list.vue?vue&type=script&lang=ts"
export * from "./list.vue?vue&type=script&lang=ts"
import style0 from "./list.vue?vue&type=style&index=0&id=c4c141fe&prod&lang=less&scoped=true"
import style1 from "./list.vue?vue&type=style&index=1&id=c4c141fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c141fe",
  null
  
)

export default component.exports